import { $t } from '~/i18n.js'
import { EditOutlined, PrinterOutlined } from "@ant-design/icons";
import { Button, Card, Tag, Tooltip } from 'antd'
import React, { useEffect, useState } from 'react'
import { _parseDate, getAge } from "~/lib/localize.js";
import { HelpBubble } from "../../help/helpBubble.jsx";
import { DtoTrainingUpdateModal } from './dtoTraining.UpdateModal.jsx'
import { api } from "~/lib/api.js";
import { KNVVLStatus } from './KNVVLComponents.jsx';
import { useSelector } from 'react-redux';
import { ExtrasDescription } from '~/components/form/extras.jsx';
import { MedicalHistory } from './medicalHistory.jsx';

const DTOtrainingRow = ({
  canWijzigDTO,
  editRow,
  cluster,
  active_training,
  onExportClick,
}) => (
  <Card
    size="small"
    title={cluster.name}
    extra={
      [
        canWijzigDTO ? (
        <Button
          shape="circle"
          size="small"
          type="primary"
          onClick={() =>
            editRow({
              status: "concept",
              cluster_id: cluster.id,
              name: cluster.name,
              // overwrite active_Training, e.g. status if applicable
              ...active_training,
            })
          }
          icon={<EditOutlined />}
        />
      ) : null,

      canWijzigDTO ? (
            <Button
              style={{ marginLeft: 8 }}
              shape="circle"
              size="small"
              disabled={!active_training}
              onClick={() => onExportClick(active_training?.id)}
            >
              <PrinterOutlined />
            </Button>
          ) : null
      ].filter(f => f)
    }
    style={{ marginBottom: 12 }}
  >
    <div>
      
      {active_training && (
        <div>
          {active_training.status === "started" && (
            <p><span className='label'>{$t("gestart")}</span> {_parseDate(active_training.started_date)}</p>
          )}

          {active_training.status === "completed" && (
            <p><span className='label'>{$t("afgerond")}</span> {_parseDate(active_training.completed_date)}</p>
          )}

          {active_training.status === "discontinued" && (
            <p><span className='label'>{$t("gestaakt")}</span> {_parseDate(active_training.updated_date)}</p>
          )}

          
        </div>
      )}

      <span className="gray small">{cluster.curriculum_versie}</span>
      
    </div>
  </Card>
);

export const DTOtrainingTab = ({
  canWijzigDTO,
  dto_training,
  bevoegdheden,
  pilot,
  onAddDTOprogramme,
  gegevens,
}) => {
  
  const { club } = useSelector((state) => state.persist);
  const hasKNVVL = club?.association === 'knvvl';

  const [participatingTrainings, setCurrent] = useState(null);
  useEffect(
    () => dto_training && setCurrent(dto_training),
    [dto_training, setCurrent]
  );

  async function onExportClick(id) {
    api.openFileGET(`bevoegdheid/${id}/export_training.json`);
  }

  const [activeTraining, setActiveTraining] = useState(null);
  return (
    <div>
      {activeTraining && (
        <DtoTrainingUpdateModal
          data={activeTraining}
          visible={activeTraining != null}
          onClose={() => setActiveTraining(null)}
          pilot={pilot}
          saveNewResult={(newData) => {
            // save new data to activeTraining cluster
            const newSet = { ...participatingTrainings };
            newSet[activeTraining.cluster_id] = newData;
            setCurrent(newSet);
            if (onAddDTOprogramme) onAddDTOprogramme(newSet);
          }}
        />
      )}

      {(gegevens?.brevet_nummer ||
        gegevens?.aml_nummer ||
        gegevens?.knvvl ||
        gegevens?.date_of_birth) && (
        <div style={{ marginBottom: 12 }}>
          <p className="subtitle">{$t("DTO gegevens")}</p>
          {gegevens?.brevet_nummer && (
            <p>
              {$t("(SPL) Brevet nummer")}: {gegevens?.brevet_nummer}{" "}
              {gegevens?.date_brevet_afgifte &&
                `(${_parseDate(gegevens.date_brevet_afgifte)})`}
            </p>
          )}
          {gegevens?.aml_nummer && (
            <p>
              {$t("Technicus licentie (AML) nummer")}: {gegevens?.aml_nummer}
            </p>
          )}
          {gegevens?.knvvl && (
            <p>
              {$t("KNVvL lidnummer")}: {gegevens?.knvvl}
            </p>
          )}

          {hasKNVVL && (
            <p className='row' style={{gap: 8}}>
              {$t("KNVvL status")}: <KNVVLStatus association={pilot.association} userGroups={pilot.group_keys}/>
            </p>
          )}

          {gegevens?.date_of_birth && (
            <p>
              <span className='gray label'>{$t("Geboortedatum")}</span> {_parseDate(gegevens?.date_of_birth)} ({getAge(gegevens?.date_of_birth)})
            </p>
          )}
        </div>
      )}

      <ExtrasDescription
        style={{marginBottom: 12}}
        extraData={pilot?.extra}
        extras={club?.member_extras}
      />

      <p className="subtitle">
        {$t("Overzicht van alle DTO training programma's")}
        <HelpBubble
          content={$t(
            "Een lid kan door een instructeur coordinator (HoT) worden toegevoegd aan een programma."
          )}
        />
      </p>
      
      <div>
        {bevoegdheden &&
          bevoegdheden.map(
            (cluster) =>
              cluster.is_dto && (
                <DTOtrainingRow
                  key={cluster.name}
                  canWijzigDTO={canWijzigDTO}
                  editRow={setActiveTraining}
                  cluster={cluster}
                  active_training={
                    participatingTrainings &&
                    participatingTrainings[cluster.id]
                  }
                  onExportClick={onExportClick}
                />
              )
          )}
      </div>

      {(pilot.guest_clubs) && <section>
        <p className="subtitle">{$t("Gast clubs")} <HelpBubble content={$t('Vlieger is actief als gastvlieger bij de volgende clubs')}/></p>

        {pilot.guest_clubs && 
          <div>
            <table className="dataBlock">
            <tbody>
            {pilot.guest_clubs.map((club, key) => <tr key={key}>
              <td className='col'>{club.full_name} </td>
              <td className='col'>{!club.is_active ? <Tag color="red">{$t("deactief")}</Tag> : " "}</td>
              </tr> )}
              </tbody>
            </table>
          </div>
        }


      </section>
      }
      
      <MedicalHistory medicalHistory={pilot?.gegevens?.medical_history} />
    </div>
  );
};
